<template>
  <v-card outlined class="rounded-xl">
    <v-card-text v-if="!isLoading">
      <div
        v-for="(notification, idx) in notifications"
        :key="notification.id"
        class="pb-4"
      >
        <!-- Email Notification -->
        <EmailNotification
          v-if="notification.stringId === 'NIGHTLYSALE'"
          :notification="notification"
          :LocationId="LocationId"
          @reload="loadNotifications"
        />

        <!-- Sales Alert -->
        <SaleAlertNotification
          v-else-if="notification.stringId === 'SALESALERT'"
          :notification="notification"
          :LocationId="LocationId"
          @reload="loadNotifications"
        />

        <!-- Example if you later want to add -->
        <!-- <InvoiceDeleteNotification
          v-else-if="notification.stringId === 'INVOICEDELETEALERT'"
          :notification="notification"
          :LocationId="LocationId"
          @reload="loadNotifications"
        /> -->

        <!-- Divider only between items -->
        <v-divider v-if="idx < notifications.length - 1" class="my-3" />
      </div>
    </v-card-text>

    <v-card-text v-else class="d-flex justify-center pa-6">
      <v-progress-circular indeterminate color="primary" />
    </v-card-text>
  </v-card>
</template>

<script>
import EmailNotification from "@/modules/Location/components/notification/EmailNotification.vue";
import SaleAlertNotification from "@/modules/Location/components/notification/SaleAlertNotification.vue";
import InvoiceDeleteNotification from "@/modules/Location/components/notification/InvoiceDeleteAlert.vue";
import locationService from "@/modules/Location/service.js";
import settingsService from "../../Settings/service";

export default {
  name: "location-view-notifications",
  props: ["LocationId", "location"],
  components: {
    EmailNotification,
    SaleAlertNotification,
    InvoiceDeleteNotification,
  },
  data() {
    return {
      notifications: [],
      isLoading: false,
    };
  },
  async created() {
    this.loadNotifications();
  },
  methods: {
    async loadNotifications() {
      try {
        this.isLoading = true;

        // 1. Get all available notification types
        const { data: allNotifications } =
          await settingsService.Notification.getAll();
        this.notifications = allNotifications;

        // 2. Get current notification settings for this location
        const { data: currentSettings } =
          await locationService.Settings.Notifications.get(this.LocationId);

        // 3. Attach NotificationSetting to each relevant notification
        this.notifications = this.notifications.map((n) => {
          const setting = currentSettings.find(
            (s) => s.NotificationId === n.id
          );
          return {
            ...n,
            NotificationSetting: setting || null,
          };
        });
      } catch (err) {
        console.error("Error loading notifications:", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>